import { gql, TypedDocumentNode } from '@apollo/client';

import {
  FavoriteCreateInput,
  FavoriteDetail,
  FavoritesListTreeConnection,
  FavoriteUpdateInput,
} from '@atom/types/favorite';

import { BASE_FAVORITE_LIST_FRAGMENT } from './favoritesList';

export const BASE_FAVORITE_FRAGMENT = gql`
  fragment BaseFavorite on Favorite {
    id
    subjectType
    subjectId
    subjectName
    listIds
    data {
      colorId
      assetType
      categories {
        id
        name
      }
      photoUrl
      email
      firstName
      lastName
      markerId
      locationType
      schemaId
      isMaterial
      inactive
    }
    createdDate
    createdBy {
      firstName
      lastName
    }
  }
`;

export const CREATE_FAVORITE: TypedDocumentNode<
  { favoriteCreate: FavoriteDetail },
  { input: FavoriteCreateInput }
> = gql`
  mutation favoriteCreate($input: FavoriteCreateInput!) {
    favoriteCreate(input: $input) {
      ...BaseFavorite
    }
  }
  ${BASE_FAVORITE_FRAGMENT}
`;

export const UPDATE_FAVORITE: TypedDocumentNode<
  { favoriteUpdate: FavoritesListTreeConnection },
  { input: FavoriteUpdateInput }
> = gql`
  mutation favoriteUpdate($input: FavoriteUpdateInput!) {
    favoriteUpdate(input: $input) {
      totalCount
      totalUniqueFavorites
      favoritesLists {
        ...BaseFavoritesList
      }
    }
  }
  ${BASE_FAVORITE_LIST_FRAGMENT}
`;
